import { Address } from "@/Common/Api/Contacts/Dto/Address";
import { ContactPoint } from "@/Common/Api/Contacts/Dto/ContactPoint";
import { Email } from "@/Common/Api/Contacts/Dto/Email";
import { PhoneNumber } from "@/Common/Api/Contacts/Dto/PhoneNumber";
import { GuidHelper } from "@/Common/Helpers/GuidHelper";
import { ContactPointType } from "@/Common/Models/Contacts/Enums/ContactPointType";
import { PhoneType } from "@/Common/Models/Contacts/Enums/PhoneType";

class ContactsEditModelHelper {
    public static createNewEmptyContactPoint(contactId: string): ContactPoint {
        const contactPoint = new ContactPoint();
        contactPoint.Id = GuidHelper.NewGuid();
        contactPoint.ContactId = contactId;
        contactPoint.ContactPointTypeLookupId = cacheStore.GetContactPointTypeLookups()[0].LookupID;
        return contactPoint;
    }

    public static createNewEmptyAddress(contactPoint: ContactPoint): Address {
        const address = new Address();
        address.IsValid = false;
        address.ContactPoint_id = contactPoint.Id;
        address.AvailableContactPointTypeLookupIds = cacheStore.GetContactPointTypeLookups();
        address.ContactPointTypeLookupId = cacheStore.GetContactPointTypeLookups()[0].LookupID;
        address.AvailableCountryLookupIds = cacheStore.GetCountryLookups();
        address.CountryLookupId = cacheStore.GetDefaultCountryForActiveSite().LookupID;
        address.AvailableCountryRegionLookupIds = cacheStore.GetCountryRegionLookups(cacheStore.GetDefaultCountryForActiveSite());
        address.StateLookupId = cacheStore.GetDefaultRegionForActiveSite().LookupID;
        address.ZipCode = "";
        address.IsPreferred = false;
        return address;
    }

    public static createNewEmptyPhone(contactPoint: ContactPoint): PhoneNumber {
        const phone = new PhoneNumber();
        phone.IsValid = false;
        phone.ContactPoint_id = contactPoint.Id;
        phone.ContactPointTypeLookupId = cacheStore.getLookupByContactPointType(ContactPointType.Personal).LookupID;
        phone.PhoneTypeLookupId = cacheStore.getLookupByPhoneType(PhoneType.Mobile).LookupID;
        phone.CountryLookupId = cacheStore.GetDefaultCountryForActiveSite().LookupID;
        phone.Number = "";
        phone.Extension = null;
        phone.Notes = "";
        phone.IsPreferred = false;
        phone.NotificationsEnabled = false;
        return phone;
    }

    public static createNewEmptyEmail(contactPoint: ContactPoint): Email {
        const email = new Email();
        email.IsValid = false;
        email.ContactPoint_id = contactPoint.Id;
        email.IsOkToContact = false;
        email.ContactPointTypeLookupId = cacheStore.getLookupByContactPointType(ContactPointType.Personal).LookupID;
        email.Address = "";
        email.NotificationsEnabled = false;
        return email;
    }
}

export { ContactsEditModelHelper };
